export enum SLIDES_TYPE {
    IMAGE = 'ImageSlide',
    VIDEO = 'VideoSlide',
}

export enum SUPPORTED_TYPES {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
}
